import React from 'react';

/**
 * Compact SVG sparkline. Data is an array of numbers; rendered into a 200×36 polyline + dots.
 */
export function Sparkline({ data, max }) {
  const w = 200;
  const h = 36;
  if (!data || data.length === 0) return null;
  const maxV = max || Math.max(...data, 1);
  const step = w / Math.max(data.length - 1, 1);
  const points = data
    .map((v, i) => `${i * step},${h - (v / maxV) * (h - 4) - 2}`)
    .join(' ');
  return (
    <svg width={w} height={h} className="overflow-visible">
      <polyline fill="none" stroke="currentColor" strokeWidth="2" points={points} />
      {data.map((v, i) => (
        <circle
          key={`pt-${i}-${v}`}
          cx={i * step}
          cy={h - (v / maxV) * (h - 4) - 2}
          r="2.5"
          fill="currentColor"
        />
      ))}
    </svg>
  );
}
